// Wrapper component that shows desktop or mobile version based on screen size.
import FeedbackDesktop from './FeedbackDesktop';
import FeedbackMobile from './FeedbackMobile';

export default function Feedback() {
  return (
    <>
      {/* Desktop version - hidden on mobile/tablet */}
      <div className="hidden lg:block">
        <FeedbackDesktop />
      </div>

      {/* Mobile version - hidden on desktop */}
      <div className="lg:hidden">
        <FeedbackMobile />
      </div>
    </>
  );
}
